import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NOINDEX_PREFIXES = [
  "/app",
  "/w/",
  "/rsvp/",
  "/invite/",
  "/onboarding",
  "/verify-email",
  "/reset",
  "/mobile",
  "/login",
  "/register",
] as const;

export function pathnameRequiresNoindex(pathname: string): boolean {
  return NOINDEX_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(prefix));
}

function setRobotsMeta(content: string | null) {
  let el = document.querySelector('meta[name="robots"]');
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Force noindex for 404 and similar non-indexable views. */
export function useRobotsNoindex() {
  useEffect(() => {
    setRobotsMeta("noindex,nofollow");
    return () => setRobotsMeta(null);
  }, []);
}

/** Sync robots meta with route — private/app surfaces stay out of the index. */
export function useRobotsMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathnameRequiresNoindex(pathname)) {
      setRobotsMeta("noindex,nofollow");
    } else {
      setRobotsMeta(null);
    }
    return () => setRobotsMeta(null);
  }, [pathname]);
}
